// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1D0LH","content":"styles_content__YPFLg","selectAll":"styles_selectAll__28l1d"};